import React from 'react';

const Shuffle = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 16 16"
  >
    <g fill="#FFF">
      <path d="M8.673 6a.644.644 0 00.5-.245c1.193-1.452 3.046-2.392 4.736-2.412l-.472.652a.796.796 0 00.104 1.045c.125.11.273.163.42.163a.653.653 0 00.528-.279l1.303-1.795c.014-.015.022-.033.036-.049l.01-.014c.003-.005.004-.01.008-.015A.774.774 0 0016 2.596a.767.767 0 00-.224-.544L14.49.279c-.233-.32-.657-.373-.948-.115a.796.796 0 00-.105 1.045l.471.649c-2.054.02-4.3 1.152-5.734 2.9a.797.797 0 00.048 1.05c.128.128.29.192.451.192zm-2.8 1.189c-1.27 1.25-3.5 2.195-5.187 2.195-.378 0-.686.362-.686.808 0 .446.308.808.686.808 2.004 0 4.556-1.082 6.068-2.572.29-.286.33-.796.086-1.138-.243-.343-.677-.388-.967-.101z" />
      <path d="M15.777 9.992L14.507 8.3a.637.637 0 00-.937-.11.739.739 0 00-.104.997l.462.614C11.55 9.782 9.71 7.987 7.766 6.088 5.708 4.078 3.58 2 .666 2 .3 2 0 2.318 0 2.71c0 .391.299.709.666.709 2.396 0 4.243 1.805 6.199 3.715 2.05 2.003 4.172 4.074 7.072 4.088l-.471.626a.74.74 0 00.103.997c.124.104.27.155.415.155.197 0 .39-.092.522-.266l1.288-1.713c.014-.014.022-.031.035-.046l.01-.015c.004-.004.004-.01.008-.014a.722.722 0 00.153-.433.724.724 0 00-.223-.52z" />
    </g>
  </svg>
);

export default Shuffle;
